import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import Routes from "./routes";
import defaultTheme from "./theme";
import Store from "./store";
import { i18n } from "./i18n";

function App() {
  // 語系預設
  // const sysLang = (navigator.language||navigator.userLanguage||navigator.browserLanguage||navigator.systemLanguage).toLowerCase();
  // const defaultLang = (['zh','zh-cn','zh-hk','zh-mo','zh-sg','zh-tw']).includes(sysLang)? 'zh':'en';
  const lang = "zh";
  return (
    <ThemeProvider theme={defaultTheme}>
      <Store.Provider value={{ text: i18n[lang], lang }}>
        <Router>
          <Routes lang={lang} />
        </Router>
      </Store.Provider>
    </ThemeProvider>
  );
}

export default App;
